import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../../components/DashboardLayout';
import { User, Save, X } from 'lucide-react';
import { MessageModal } from '../../components/modals/MessageModal';
export function EditProfilePage() {
  const navigate = useNavigate();
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: 'Amit Sharma',
    email: 'amit.sharma@example.com',
    phone: '+91 98765 43210',
    address: '123 MG Road',
    city: 'Pune',
    state: 'Maharashtra',
    pincode: '411001',
    country: 'India'
  });
  const navItems = [{
    label: 'Dashboard',
    icon: User,
    path: '/dashboard'
  }, {
    label: 'Profile',
    icon: User,
    path: '/profile'
  }];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsMessageModalOpen(true);
    setTimeout(() => {
      navigate('/profile');
    }, 2000);
  };
  const handleCancel = () => {
    navigate('/profile');
  };
  return <DashboardLayout title="Edit Profile" navItems={navItems} userInitials="AS" data-id="element-5242">
      <div className="max-w-3xl mx-auto" data-id="element-5243">
        <h1 className="text-2xl font-bold mb-8" data-id="element-5244">Edit Profile</h1>

        <form onSubmit={handleSubmit} className="bg-white border border-gray-300 p-8" data-id="element-5245">
          <div className="space-y-6" data-id="element-5246">
            {/* Basic Information */}
            <div data-id="element-5247">
              <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-5248">
                Basic Information
              </h2>
              <div className="space-y-4" data-id="element-5249">
                <div data-id="element-5250">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5251">
                    Full Name *
                  </label>
                  <input type="text" required value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5252" />
                </div>

                <div data-id="element-5253">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5254">
                    Email Address *
                  </label>
                  <input type="email" required value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5255" />
                  <p className="text-xs text-gray-500 mt-1" data-id="element-5256">
                    Changing email will require verification
                  </p>
                </div>

                <div data-id="element-5257">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5258">
                    Phone Number *
                  </label>
                  <input type="tel" required value={formData.phone} onChange={e => setFormData({
                  ...formData,
                  phone: e.target.value
                })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5259" />
                  <p className="text-xs text-gray-500 mt-1" data-id="element-5260">
                    Changing phone will require OTP verification
                  </p>
                </div>
              </div>
            </div>

            {/* Address Information */}
            <div data-id="element-5261">
              <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-5262">
                Address Information
              </h2>
              <div className="space-y-4" data-id="element-5263">
                <div data-id="element-5264">
                  <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5265">
                    Street Address
                  </label>
                  <input type="text" value={formData.address} onChange={e => setFormData({
                  ...formData,
                  address: e.target.value
                })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5266" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5267">
                  <div data-id="element-5268">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5269">
                      City
                    </label>
                    <input type="text" value={formData.city} onChange={e => setFormData({
                    ...formData,
                    city: e.target.value
                  })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5270" />
                  </div>

                  <div data-id="element-5271">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5272">
                      State
                    </label>
                    <input type="text" value={formData.state} onChange={e => setFormData({
                    ...formData,
                    state: e.target.value
                  })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5273" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5274">
                  <div data-id="element-5275">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5276">
                      PIN Code
                    </label>
                    <input type="text" value={formData.pincode} onChange={e => setFormData({
                    ...formData,
                    pincode: e.target.value
                  })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5277" />
                  </div>

                  <div data-id="element-5278">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-5279">
                      Country
                    </label>
                    <select value={formData.country} onChange={e => setFormData({
                    ...formData,
                    country: e.target.value
                  })} className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-5280">
                      <option value="India" data-id="element-5281">India</option>
                      <option value="USA" data-id="element-5282">USA</option>
                      <option value="UK" data-id="element-5283">UK</option>
                      <option value="UAE" data-id="element-5284">UAE</option>
                      <option value="Singapore" data-id="element-5285">Singapore</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="flex justify-end gap-3 pt-6 border-t border-gray-200" data-id="element-5286">
              <button type="button" onClick={handleCancel} className="flex items-center gap-2 px-6 py-3 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-5287">
                <X className="w-4 h-4" data-id="element-5288" />
                Cancel
              </button>
              <button type="submit" className="flex items-center gap-2 px-6 py-3 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-5289">
                <Save className="w-4 h-4" data-id="element-5290" />
                Save Changes
              </button>
            </div>
          </div>
        </form>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Profile Updated" message="Your profile has been updated successfully." type="success" data-id="element-5291" />
    </DashboardLayout>;
}